module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOdJREFUeNpi9PDw+M8ABUwMSACFAxBAjDBlTBjSAAEEltqxYwcjhknIAiAAEECM6AIwlY4g7ciCLEC8H6iaAaeD8AoCBBCyRY5AnA/EAdgUskDpDUAHHADSB7C5EKfT8ZmYCDRxAUwQm2aiTQQIIKIVwoJiA9TX+BUC3RcI9bUjIRNhIB+vr4lxJxMDkYBohSxQzzAiBXYBkOqnvRsBAozomCHJL0hJMhBZEmjZelzpmBivNGKRn0iJC88DXbQBasgHIK4n1XXoBjJADQigVhiiZEJiALa0Q/VYZmKgMiDJy7iyB029DACc3E6lOEtlAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/jieshao.png
// module id = peW4
// module chunks = 1